"use strict";
// Class definition
import Swiper from "swiper";
import {Autoplay, Grid, Navigation, Pagination, Thumbs} from "swiper/modules"
import Swal from 'sweetalert2'
import 'animate.css';
import SwiperAnimation from '@cycjimmy/swiper-animation';
import {Modal, Popover, Tab,} from 'bootstrap';
import SVGInject from '@iconfu/svg-inject';
import Cookies from 'js-cookie'
import {Fancybox} from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import {isScrolledIntoView} from "./General";
import {CountUp} from 'countup.js';

var App = function () {
    let swiperAnimation;
    var swiperUse = function () {
        Swiper.use([Navigation, Pagination, Autoplay, Thumbs, Grid]);
        swiperAnimation = new SwiperAnimation();
    }
    jQuery.fn.exists = function () {
        return this !== null && this !== undefined;
    }


    var homeSwipers = function () {

        const home_slider = new Swiper('.home-slider', {
            loop: false,
            preloadImages: false,
            effect: 'fade',
            lazy: true,

            // autoplay: {
            //     delay: 5000,
            //     disableOnInteraction: false,
            // },
            pagination: {
                el: '.home-slider .swiper-pagination',
                clickable: true
            },
            on: {
                init: function () {
                    swiperAnimation.init(this).animate();
                },
                slideChange: function (swiper) {
                    swiperAnimation.init(this).animate();

                    let activeSlide = swiper.slides[swiper.realIndex];
                    console.log(activeSlide.querySelector('img').getAttribute('slide-src'))
                    if (activeSlide.querySelector('img').getAttribute('slide-src')){
                        activeSlide.querySelector('img').setAttribute('src', activeSlide.querySelector('img').getAttribute('slide-src'));
                        activeSlide.querySelector('img').removeAttribute('slide-src');
                    }
                }
            }
        });

        const services = new Swiper('.service-slider', {
            loop: false,
            preloadImages: false,
            effect: 'fade',
            lazy: true,
            slidesPerView: 4,
            spaceBetween: 20,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: '.service-header .swiper-next',
                prevEl: '.service-header .swiper-prev',
            },
            breakpoints: {
                0: {
                    slidesPerView: 2,
                    spaceBetween: 5,
                },
                480: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 10,
                },
                1200: {
                    slidesPerView: 4,
                }
            },
        });

        const ref = new Swiper('.ref-slider', {
            loop: false,
            preloadImages: false,
            effect: 'fade',
            lazy: true,
            slidesPerView: 8,
            spaceBetween: 30,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            pagination: {
                el: '.references .swiper-pagination',
                clickable: true
            },
            breakpoints: {
                0: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                },
                576: {
                    slidesPerView: 5,
                    spaceBetween: 20,
                },
                992: {
                    slidesPerView: 6,
                    spaceBetween: 20,
                },
                1400: {
                    slidesPerView: 8,
                }
            },
        });

        const gallery_slider = new Swiper('.gallery-slider', {
            loop: false,
            preloadImages: false,
            effect: 'fade',
            lazy: true,
            slidesPerView: 6,
            spaceBetween: 10,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            breakpoints: {
                0: {
                    slidesPerView: 3,
                },
                576: {
                    slidesPerView: 4,
                },
                768: {
                    slidesPerView: 5,
                },
                1200: {
                    slidesPerView: 6,
                }
            },
        });

        const prop_slider = new Swiper('.prop-slider', {
            loop: false,
            preloadImages: false,
            effect: 'fade',
            lazy: true,
            slidesPerView: 4,
            spaceBetween: 0,
            breakpoints: {
                0: {
                    slidesPerView: 0,
                    spaceBetween: 0,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 0,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 0,
                },
                1400: {
                    slidesPerView: 4,
                    spaceBetween: 0,
                }
            },

        });

        const service_gallery_thumbs = new Swiper(".service-thumb-gallery", {
            loop: true,
            spaceBetween: 10,
            slidesPerView: 4,
            freeMode: true,
            watchSlidesProgress: true,
            breakpoints: {
                0: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                465: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 4
                },
            },
        });

        var service_gallery = new Swiper(".service-gallery", {
            loop: true,
            spaceBetween: 10,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: service_gallery_thumbs,
            },
        });

    };

    var init = function () {

        var PopupModal;
        if (screen.width <= 768 && !Cookies.get('popup')) {
            if ($('#callingPopupModal').length > 0) {
                PopupModal = new Modal(document.getElementById('callingPopupModal'))
                setTimeout(function () {
                    PopupModal.show()
                }, 4000);


                var pp = document.getElementById('callingPopupModal')
                pp.addEventListener('hidden.bs.modal', function () {
                    if ($('#neverShowAgain').is(':checked')) {
                        var inFiveMinutes = new Date(new Date().getTime() + 5 * 60 * 1000)
                        Cookies.set('popup', 'true', {expires: window.cookieTime});
                    }
                })
            }
        }
    }

    var numbers = () => {

        function isScrolledIntoView(el) {
            var elemTop = el.getBoundingClientRect().top;
            var elemBottom = el.getBoundingClientRect().bottom;

            var isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
            return isVisible;
        }

        if (document.querySelectorAll('.count').length > 0) {
            var firstScrolled = false;
            window.addEventListener('scroll', function () {
                if (!firstScrolled) {
                    if (isScrolledIntoView(document.querySelector('.count'))) {
                        document.querySelectorAll('.count').forEach(function (el) {
                            let count = new CountUp(el, el.getAttribute('data-end'));
                            if (!count.error) {
                                count.start();
                            } else {
                                console.error(count.error);
                            }
                        });
                        firstScrolled = true;
                    }
                }
            }, true);
        }


        // let demo = new CountUp('myTargetElement', 8053);
        // if (!demo.error) {
        //     demo.start();
        // } else {
        //     console.error(demo.error);
        // }
    }

    return {
        init: function () {
            Fancybox.bind('[data-fancybox]')
            swiperUse();
            homeSwipers();
            init();
            numbers();
            // intTelInput();

        },
    };
}();

// On document ready
jQuery(document).ready(function () {
    App.init();
});

